/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * WordCloudIcon
 */
export default class WordCloudIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M13.431 3.2a8.97 8.97 0 013.872 4.487L17.42 8h.599C21.408 8 24 10.6 24 14c0 3.323-2.476 5.881-5.752 5.996l-.23.004H9.044C4.856 20 1.267 17.2.27 13.2-.927 8.5 1.965 3.7 6.75 2.3c2.294-.6 4.687-.3 6.681.9zm-4.33.8c-.6 0-1.2.1-1.8.3-3.8 1.1-6 4.8-5.1 8.5.778 2.919 3.45 5.08 6.541 5.195l.259.005h9C20.2 18 22 16.2 22 14a4.013 4.013 0 00-3.801-3.995L18 10h-1.2c-.5 0-.9-.4-1-.8-.5-1.8-1.7-3.4-3.3-4.3-1.1-.6-2.2-.9-3.4-.9zM19 14a1 1 0 01.117 1.993L19 16h-4a1 1 0 01-.117-1.993L15 14h4zm-7 0a1 1 0 01.117 1.993L12 16H8a1 1 0 01-.117-1.993L8 14h4zm3-3a1 1 0 010 2H5a1 1 0 010-2zM6.014 8H12a1 1 0 01.117 1.993L12 10H6.014a1 1 0 01-.116-1.993L6.014 8H12z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

